import ikson from './ikson.js';

(function (window, document) {
    'use strict';

    function initPlayer() {
        if (window.iksonPlayer
            || typeof window.WaveSurfer === 'undefined'
            || !document.getElementById('waveform')
            || !document.getElementById('main-play-icon')) {
            return;
        }

        // Fix up for prefixing, get audiocontext and use it to check chrome errors regarding autoplay
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        var context = window.AudioContext ? new window.AudioContext() : null;

        // Format elapsed/total time for the complete track.
        const formatTimecode = function (time) {
            time = Number.isFinite(time) && time >= 0 ? time : 0;

            return [
                Math.floor((time % 3600) / 60), // minutes
                ('00' + Math.floor(time % 60)).slice(-2) // seconds
            ].join(':');
        };

        const parseTimecode = function (timecode) {
            var parts = String(timecode || '').split(':').map(Number);

            if (parts.length !== 2 || !Number.isFinite(parts[0]) || !Number.isFinite(parts[1])) {
                return 0;
            }

            return (parts[0] * 60) + parts[1];
        };

        // player is hidden, this function will show it and run song current time.
        const showPlayer = function () {
            var playerElement = document.getElementById('waveform-player');

            playerElement.style.transform = 'translateX(0%)';
            playerElement.setAttribute('aria-hidden', 'false');
            document.body.classList.add('music-library-player-visible');
            document.getElementById('wave-progress').innerHTML = formatTimecode(wavesurfer.getCurrentTime());
        }

        // Get all attr-data ot this and assign to ID's on main player
        const updatePlayerData = function (songPoster, songTitle, songArtist, songLink, songDuration) {
            document.getElementById('songPoster').src = songPoster;
            document.getElementById('songTitle').innerText = songTitle;
            document.getElementById('songAuthor').innerText = songArtist;
            document.getElementById('songLink').href = songLink;
            document.getElementById('wave-total').innerText = songDuration || formatTimecode(wavesurfer.getDuration());
        }

        var mainPlayerButton = document.getElementById('main-play-icon');
        var pendingPlayback = null;
        var activeTrackId = '';
        var loadedTrackId = '';
        var activeTrackDuration = 0;
        var playerStateFrame = null;
        var activeTrackRequest = null;
        var activeObjectUrl = '';
        var autoplayFadeSeconds = 0;
        var fadeInTrackId = '';
        var fadeOutput = null;
        var volume = 1;
        var trackGain = 1;
        try {
            var storedVolume = localStorage.getItem('iksonPlayerVolume');
            if (storedVolume !== null && Number.isFinite(Number(storedVolume))) {
                volume = Math.min(1, Math.max(0, Number(storedVolume)));
            }
        } catch (_) {}
        var unmutedVolume = volume || 1;
        var volumeControl = document.querySelector('[data-player-volume]');

        const resumeFadeContext = function () {
            if (context && context.state !== 'running' && context.state !== 'closed') {
                context.resume().then(function () { updateAutoplayFade(false); }).catch(function () {});
            }
        };

        const restoreFadeVolume = function () {
            if (!fadeOutput) return;
            fadeOutput.gain.gain.cancelScheduledValues(context.currentTime);
            fadeOutput.gain.gain.setValueAtTime(volume * trackGain, context.currentTime);
        };

        // One gain stage on the existing player for volume and paid automatic fades.
        // MediaElement.volume cannot reliably fade audio on iPhone. If Web Audio
        // cannot run, keep ordinary audible playback instead of routing into it.
        const updateAutoplayFade = function (starting) {
            var media = document.querySelector('#waveform audio');
            if (fadeOutput && fadeOutput.media !== media) {
                fadeOutput.source.disconnect();
                fadeOutput.gain.disconnect();
                fadeOutput = null;
            }
            if (!media) return;
            media.muted = volume === 0;
            var outputVolume = volume * trackGain;
            if (!context || context.state !== 'running') {
                if (!fadeOutput) media.volume = Math.min(1, outputVolume);
                restoreFadeVolume();
                return;
            }
            if (!fadeOutput && !autoplayFadeSeconds && outputVolume === 1) return;
            var duration = media.duration;
            var time = media.currentTime;
            var fading = autoplayFadeSeconds && (starting || (!media.paused && !media.seeking))
                && Number.isFinite(duration) && duration > autoplayFadeSeconds * 2;
            var level = outputVolume;
            if (fading) {
                level *= Math.min(1, Math.max(0, duration - time) / autoplayFadeSeconds);
                if (fadeInTrackId === activeTrackId) level *= Math.min(1, time / autoplayFadeSeconds);
            }
            if (!fadeOutput) {
                // A cross-origin stream must have loaded with CORS before it
                // can produce audible output through Web Audio.
                var sourceUrl = new URL(media.currentSrc || media.src, document.baseURI);
                if (sourceUrl.protocol !== 'blob:' && sourceUrl.origin !== window.location.origin && media.crossOrigin !== 'anonymous') { media.volume = Math.min(1, outputVolume); return; }
                var gain = context.createGain();
                gain.gain.value = level;
                gain.connect(context.destination);
                try {
                    var source = context.createMediaElementSource(media);
                    source.connect(gain);
                    fadeOutput = { media: media, gain: gain, source: source };
                    media.volume = 1;
                } catch (_) {
                    gain.disconnect();
                    media.volume = Math.min(1, outputVolume);
                    return;
                }
            }
            var param = fadeOutput.gain.gain;
            var now = context.currentTime;
            param.cancelScheduledValues(now);
            param.setValueAtTime(level, now);
            // Schedule on the audio clock, independent of screen redraws or
            // background-tab timer throttling. Native media events resync seeks,
            // pauses and buffering; no second audio source is needed.
            if (fading) {
                var rate = media.playbackRate || 1;
                if (fadeInTrackId === activeTrackId && time < autoplayFadeSeconds) {
                    param.linearRampToValueAtTime(outputVolume, now + (autoplayFadeSeconds - time) / rate);
                }
                var fadeOutStart = duration - time - autoplayFadeSeconds;
                if (fadeOutStart > 0) param.setValueAtTime(outputVolume, now + fadeOutStart / rate);
                param.linearRampToValueAtTime(0, now + Math.max(0, duration - time) / rate);
            }
        };

        if (context) context.addEventListener('statechange', function () {
            if (context.state === 'running') updateAutoplayFade(false);
        });

        document.addEventListener('ikson:player-interaction', function () {
            fadeInTrackId = '';
            restoreFadeVolume();
            // Resume in the existing play/seek gesture; never create another player.
            resumeFadeContext();
        });

        const renderVolume = function () {
            if (!volumeControl) return;
            var percent = Math.round(volume * 100);
            volumeControl.querySelector('input').value = percent;
            volumeControl.querySelector('input').setAttribute('aria-valuetext', percent + ' percent');
            volumeControl.querySelector('output').textContent = percent + '%';
            volumeControl.querySelector('summary').setAttribute('aria-label', percent ? 'Volume, ' + percent + ' percent' : 'Volume, muted');
            volumeControl.querySelector('button').textContent = percent ? 'Mute' : 'Unmute';
            volumeControl.classList.toggle('is-muted', percent === 0);
        };
        const changeVolume = function (value) {
            volume = Math.min(1, Math.max(0, value));
            if (volume) unmutedVolume = volume;
            try { localStorage.setItem('iksonPlayerVolume', String(volume)); } catch (_) {}
            resumeFadeContext();
            updateAutoplayFade(false);
            renderVolume();
        };
        if (volumeControl) {
            volumeControl.querySelector('input').addEventListener('input', function (event) {
                changeVolume(Number(event.target.value) / 100);
            });
            volumeControl.querySelector('button').addEventListener('click', function () {
                changeVolume(volume ? 0 : unmutedVolume);
            });
            document.addEventListener('click', function (event) {
                if (!volumeControl.contains(event.target)) volumeControl.open = false;
            });
            volumeControl.addEventListener('keydown', function (event) {
                if (event.key === 'Escape' && volumeControl.open) {
                    event.preventDefault();
                    volumeControl.open = false;
                    volumeControl.querySelector('summary').focus();
                }
            });
            renderVolume();
        }

        const playerState = function () {
            var mediaDuration = wavesurfer ? wavesurfer.getDuration() : 0;
            var currentTime = wavesurfer ? wavesurfer.getCurrentTime() : 0;

            if (pendingPlayback) {
                currentTime = pendingPlayback.startTime;
                mediaDuration = activeTrackDuration;
            }

            return {
                trackId: activeTrackId,
                isPlaying: Boolean(activeTrackId !== '' && wavesurfer && wavesurfer.isPlaying()),
                currentTime: Number.isFinite(currentTime) ? currentTime : 0,
                duration: Number.isFinite(mediaDuration) && mediaDuration > 0 ? mediaDuration : activeTrackDuration
            };
        };

        const publishPlayerState = function () {
            if (playerStateFrame !== null) {
                return;
            }

            playerStateFrame = window.requestAnimationFrame(function () {
                playerStateFrame = null;
                document.dispatchEvent(new CustomEvent('ikson:player-state', {
                    detail: playerState()
                }));
            });
        };

        const syncMusicLibraryTrackRows = function () {
            var isPlaying = activeTrackId !== '' && !mainPlayerButton.classList.contains('paused');

            document.querySelectorAll('[data-music-library-track-row]').forEach(function (row) {
                var isActive = row.getAttribute('data-trackid') === activeTrackId;
                var title = row.getAttribute('data-title') || 'track';

                row.classList.toggle('is-active-track', isActive);
                row.classList.toggle('is-playing-track', isActive && isPlaying);

                row.querySelectorAll('[data-music-library-track-toggle]').forEach(function (control) {
                    if (control.disabled) {
                        return;
                    }

                    control.setAttribute('aria-pressed', isActive && isPlaying ? 'true' : 'false');
                    control.setAttribute('aria-label', (isActive && isPlaying ? 'Pause ' : 'Play ') + title);
                });

            });
        };

        var compactPlayerMediaQuery = window.matchMedia('(max-width: 767px)');
        var wavesurferOptions = {
            container: '#waveform',
            waveColor: '#4e4e4e',
            progressColor: '#c9c9c9',
            height: 64,
            cursorWidth: 2,
            barWidth: 2,
            barGap: 1,
            barRadius: 2,
            normalize: true,
            // Scale the complete track waveform into the available player width.
            fillParent: true,
            backend: 'MediaElement'
        };

        if (context) {
            wavesurferOptions.audioContext = context;
        }

        // Keep the persistent waveform prominent without overwhelming compact screens.
        if (compactPlayerMediaQuery.matches) {
            wavesurferOptions.height = 52;
        }

        // Init Player
        var wavesurfer = WaveSurfer.create(wavesurferOptions);

        const updateFullDuration = function () {
            var duration = wavesurfer.getDuration();

            if (Number.isFinite(duration) && duration > 0) {
                document.getElementById('wave-total').innerText = formatTimecode(duration);
            }
        };

        const updatePlaybackProgress = function () {
            var currentTime = wavesurfer.getCurrentTime();

            document.getElementById('wave-progress').innerHTML = formatTimecode(currentTime);
            localStorage.setItem('currentTime', currentTime);
            localStorage.setItem('isPlaying', 'true');
            showPlayer();
            publishPlayerState();
        };

        const syncSeekProgress = function () {
            var currentTime = wavesurfer.getCurrentTime();

            document.getElementById('wave-progress').innerHTML = formatTimecode(currentTime);
            localStorage.setItem('currentTime', currentTime);
            publishPlayerState();
        };

        const enablePlayerScrubbing = function () {
            var waveformElement = document.getElementById('waveform');
            var activePointerId = null;

            if (!waveformElement || !window.PointerEvent) {
                return;
            }

            var seekFromPointer = function (event) {
                var rect = waveformElement.getBoundingClientRect();
                var duration = wavesurfer.getDuration();

                if (!duration || !rect.width) {
                    return;
                }

                var position = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));

                wavesurfer.seekTo(position);
                window.requestAnimationFrame(syncSeekProgress);
            };

            var releasePointer = function (event) {
                if (event.pointerId !== activePointerId) {
                    return;
                }

                if (waveformElement.hasPointerCapture(event.pointerId)) {
                    waveformElement.releasePointerCapture(event.pointerId);
                }

                activePointerId = null;
            };

            waveformElement.addEventListener('pointerdown', function (event) {
                if (event.button !== 0) {
                    return;
                }

                document.dispatchEvent(new CustomEvent('ikson:player-interaction'));
                activePointerId = event.pointerId;
                waveformElement.setPointerCapture(activePointerId);
                event.preventDefault();
                seekFromPointer(event);
            });

            waveformElement.addEventListener('pointermove', function (event) {
                if (event.pointerId !== activePointerId) {
                    return;
                }

                event.preventDefault();
                seekFromPointer(event);
            });

            waveformElement.addEventListener('pointerup', function (event) {
                if (event.pointerId === activePointerId) {
                    seekFromPointer(event);
                }

                releasePointer(event);
            });

            waveformElement.addEventListener('pointercancel', releasePointer);
        };

        enablePlayerScrubbing();

        const loadTrack = function (trackUrl, startTime, shouldPlay, encodedPeaks) {
            var peaks = window.iksonWaveformPeaks && typeof window.iksonWaveformPeaks.decode === 'function'
                ? window.iksonWaveformPeaks.decode(encodedPeaks)
                : [];
            var useLocalSeekFallback = /^(127\.0\.0\.1|localhost)$/.test(window.location.hostname)
                && typeof window.fetch === 'function'
                && typeof window.AbortController === 'function';

            if (wavesurfer.isPlaying()) {
                wavesurfer.pause();
            }

            pendingPlayback = {
                trackId: activeTrackId,
                trackUrl: trackUrl,
                mediaUrl: trackUrl,
                startTime: Number.isFinite(startTime) && startTime >= 0 ? startTime : 0,
                shouldPlay: shouldPlay
            };

            loadedTrackId = activeTrackId;

            var loadMediaSource = function (mediaUrl) {
                var mediaElement;

                if (!pendingPlayback || pendingPlayback.trackId !== activeTrackId) {
                    return;
                }

                var streamingUrl = new URL(mediaUrl, document.baseURI);
                if (/^https?:$/.test(streamingUrl.protocol) && streamingUrl.origin !== window.location.origin) {
                    // Old no-CORS audio responses can be cached without an
                    // Allow-Origin header. Give CORS playback its own cache key.
                    streamingUrl.searchParams.set('ikson_audio', 'cors-v1');
                    mediaUrl = streamingUrl.href;
                }
                pendingPlayback.mediaUrl = mediaUrl;

                // Set CORS before src: production streams from S3, which already
                // permits GET requests from ikson.com. Use WaveSurfer's native
                // element path so its URL loader cannot start a no-CORS request.
                mediaElement = document.createElement('audio');
                mediaElement.crossOrigin = 'anonymous';
                mediaElement.preload = 'auto';
                mediaElement.src = mediaUrl;
                mediaElement.style.width = '100%';
                var previousMedia = document.querySelector('#waveform audio');
                if (previousMedia) previousMedia.remove();
                wavesurfer.mediaContainer.appendChild(mediaElement);

                if (peaks.length > 0) {
                    wavesurfer.load(mediaElement, peaks, undefined, activeTrackDuration);
                } else {
                    wavesurfer.load(mediaElement);
                }

                mediaElement = document.querySelector('#waveform audio');

                if (mediaElement) {
                    ['playing', 'seeked', 'durationchange', 'ratechange'].forEach(function (event) {
                        mediaElement.addEventListener(event, function () {
                            if (event === 'playing') resumeFadeContext();
                            updateAutoplayFade(false);
                        });
                    });
                    mediaElement.addEventListener('waiting', restoreFadeVolume);
                    mediaElement.addEventListener('canplay', completePendingPlayback, { once: true });
                }
            };

            if (!useLocalSeekFallback) {
                loadMediaSource(trackUrl);
                return;
            }

            if (activeTrackRequest) {
                activeTrackRequest.abort();
            }

            activeTrackRequest = new window.AbortController();
            fetch(trackUrl, { signal: activeTrackRequest.signal })
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error('Unable to load Track audio');
                    }

                    return response.blob();
                })
                .then(function (audioBlob) {
                    if (!pendingPlayback || pendingPlayback.trackId !== activeTrackId) {
                        return;
                    }

                    if (activeObjectUrl) {
                        window.URL.revokeObjectURL(activeObjectUrl);
                    }

                    activeObjectUrl = window.URL.createObjectURL(audioBlob);
                    loadMediaSource(activeObjectUrl);
                })
                .catch(function (error) {
                    if (error.name !== 'AbortError') {
                        loadMediaSource(trackUrl);
                    }
                });
        };

        const resumeOrRestart = function () {
            var currentTime = wavesurfer.getCurrentTime();
            var duration = wavesurfer.getDuration();

            if (duration > 0 && currentTime >= duration) {
                currentTime = 0;
                wavesurfer.seekTo(0);
                localStorage.setItem('currentTime', '0');
            }

            mainPlayerButton.classList.remove("paused");
            wavesurfer.play();
            localStorage.setItem('isPlaying', 'true');
            showPlayer();
            publishPlayerState();
        };

        const togglePlayback = function () {
            document.dispatchEvent(new CustomEvent('ikson:player-interaction'));
            if (!activeTrackId) {
                return;
            }

            if (pendingPlayback && pendingPlayback.trackId === activeTrackId) {
                pendingPlayback.shouldPlay = !pendingPlayback.shouldPlay;
                mainPlayerButton.classList.toggle('paused', !pendingPlayback.shouldPlay);
                localStorage.setItem('isPlaying', pendingPlayback.shouldPlay ? 'true' : 'false');
                syncMusicLibraryTrackRows();
                publishPlayerState();
                return;
            }

            if (wavesurfer.isPlaying()) {
                mainPlayerButton.classList.add("paused");
                wavesurfer.pause();
                localStorage.setItem('isPlaying', 'false');
                syncMusicLibraryTrackRows();
                publishPlayerState();
                return;
            }

            resumeOrRestart();
            syncMusicLibraryTrackRows();
        };

        const seekToTime = function (time, shouldPlay) {
            document.dispatchEvent(new CustomEvent('ikson:player-interaction'));
            var duration = wavesurfer.getDuration();
            var target;

            if (pendingPlayback && pendingPlayback.trackId === activeTrackId) {
                pendingPlayback.startTime = Math.max(0, Number(time) || 0);
                pendingPlayback.shouldPlay = shouldPlay;
                localStorage.setItem('currentTime', pendingPlayback.startTime);
                publishPlayerState();
                return;
            }

            if (!Number.isFinite(duration) || duration <= 0) {
                publishPlayerState();
                return;
            }

            target = Math.min(duration, Math.max(0, Number(time) || 0));
            wavesurfer.seekTo(target / duration);
            localStorage.setItem('currentTime', target);

            if (shouldPlay && !wavesurfer.isPlaying()) {
                resumeOrRestart();
            } else {
                syncSeekProgress();
            }
        };

        const activateTrack = function (trigger, startTime, shouldPlay, automatic) {
            var requestedStart = Math.max(0, Number(startTime) || 0);
            var trackDuration = Number(trigger.getAttribute('data-trackseconds')) || parseTimecode(trigger.getAttribute('data-trackdur'));
            var nextTrackId = trigger.getAttribute('data-trackid') || '';

            if (trigger.getAttribute('data-media-unavailable') === 'true'
                || !trigger.getAttribute('data-track')) {
                return;
            }

            document.dispatchEvent(new CustomEvent('ikson:player-interaction'));

            if (nextTrackId !== '' && nextTrackId === activeTrackId && loadedTrackId === activeTrackId) {
                seekToTime(requestedStart, shouldPlay);
                return;
            }

            activeTrackId = nextTrackId;
            var requestedGain = Number(trigger.getAttribute('data-playback-gain'));
            trackGain = Number.isFinite(requestedGain) && requestedGain > 0 ? Math.min(2, requestedGain) : 1;
            fadeInTrackId = automatic ? nextTrackId : '';
            activeTrackDuration = trackDuration;
            localStorage.setItem('isPlaying', shouldPlay ? 'true' : 'false');
            localStorage.setItem('currentTime', requestedStart);
            localStorage.setItem('songTrackId', activeTrackId);
            localStorage.setItem('songUrl', trigger.getAttribute('data-track'));
            localStorage.setItem('songPoster', trigger.getAttribute('data-poster'));
            localStorage.setItem('songTitle', trigger.getAttribute('data-title'));
            localStorage.setItem('songArtist', trigger.getAttribute('data-artist'));
            localStorage.setItem('songLink', trigger.getAttribute('data-tracklink'));
            localStorage.setItem('songDuration', trigger.getAttribute('data-trackdur'));
            localStorage.setItem('songWaveformPeaks', trigger.getAttribute('data-waveform-peaks') || '');

            updatePlayerData(
                trigger.getAttribute('data-poster'),
                trigger.getAttribute('data-title'),
                trigger.getAttribute('data-artist'),
                trigger.getAttribute('data-tracklink'),
                trigger.getAttribute('data-trackdur')
            );

            loadTrack(trigger.getAttribute('data-track'), requestedStart, shouldPlay, trigger.getAttribute('data-waveform-peaks'));
            mainPlayerButton.classList.toggle('paused', !shouldPlay);
            syncMusicLibraryTrackRows();
            publishPlayerState();
            ikson.logPlay(activeTrackId);
        };

        window.iksonPlayer = {
            stopAndReset: function () {
                document.dispatchEvent(new CustomEvent('ikson:player-interaction'));
                if (activeTrackRequest) {
                    activeTrackRequest.abort();
                    activeTrackRequest = null;
                }

                if (activeObjectUrl) {
                    window.URL.revokeObjectURL(activeObjectUrl);
                    activeObjectUrl = '';
                }

                pendingPlayback = null;
                activeTrackId = '';
                loadedTrackId = '';
                wavesurfer.stop();
                mainPlayerButton.classList.add("paused");
                localStorage.setItem('isPlaying', 'false');
                localStorage.setItem('currentTime', '0');
                localStorage.removeItem('songTrackId');
                document.getElementById('wave-progress').innerHTML = formatTimecode(0);
                document.getElementById('waveform-player').style.transform = 'translateX(-100%)';
                document.getElementById('waveform-player').setAttribute('aria-hidden', 'true');
                document.body.classList.remove('music-library-player-visible');
                syncMusicLibraryTrackRows();
                publishPlayerState();
            },
            syncMusicLibraryTrackRows: function () {
                syncMusicLibraryTrackRows();
            },
            activateTrack: function (trigger, startTime, automatic) {
                activateTrack(trigger, startTime, true, automatic === true);
            },
            setAutoplayFade: function (seconds) {
                seconds = Math.max(0, Number(seconds) || 0);
                if (seconds === autoplayFadeSeconds) return;
                autoplayFadeSeconds = seconds;
                if (!seconds) { fadeInTrackId = ''; restoreFadeVolume(); }
                else { resumeFadeContext(); updateAutoplayFade(false); }
            },
            seekToTime: function (time, shouldPlay) {
                seekToTime(time, shouldPlay !== false);
            },
            togglePlayback: function () {
                togglePlayback();
            },
            getState: function () {
                return playerState();
            }
        };

        const completePendingPlayback = function () {
            var playback = pendingPlayback;
            var mediaElement = document.querySelector('#waveform audio');
            var expectedTrackUrl;
            var duration = wavesurfer.getDuration();

            if (!playback || !mediaElement || mediaElement.readyState < 3) {
                return;
            }

            expectedTrackUrl = new URL(playback.mediaUrl, document.baseURI).href;

            if ((mediaElement.currentSrc || mediaElement.src) !== expectedTrackUrl) {
                return;
            }

            if (playback.completing) {
                return;
            }

            playback.completing = true;
            updateFullDuration();
            activeTrackDuration = duration;

            var finishPlayback = function () {
                var startTime = Math.max(0, playback.startTime);

                if (pendingPlayback !== playback
                    || playback.trackId !== activeTrackId
                    || playback.trackId !== loadedTrackId) {
                    return;
                }

                if (duration > 0 && startTime >= duration) {
                    startTime = Math.max(0, duration - 0.05);
                }

                if (duration > 0 && Math.abs(mediaElement.currentTime - startTime) > 0.05) {
                    playback.waitingForSeek = true;
                    mediaElement.addEventListener('seeked', function () {
                        playback.waitingForSeek = false;
                        finishPlayback();
                    }, { once: true });
                    mediaElement.currentTime = startTime;
                    return;
                }

                localStorage.setItem('currentTime', startTime);
                showPlayer();

                if (playback.shouldPlay) {
                    updateAutoplayFade(true);
                    mainPlayerButton.classList.remove("paused");
                    wavesurfer.play();
                    localStorage.setItem('isPlaying', 'true');
                } else {
                    mainPlayerButton.classList.add("paused");
                    localStorage.setItem('isPlaying', 'false');
                }

                pendingPlayback = null;
                syncMusicLibraryTrackRows();
                publishPlayerState();
            };

            finishPlayback();
        };

        // WaveSurfer can emit a stale ready event while replacing MediaElements.
        // The source/readyState guard above keeps Track switching tied to the new source.
        wavesurfer.on('ready', completePendingPlayback);

        wavesurfer.on('audioprocess', updatePlaybackProgress);
        wavesurfer.on('seek', syncSeekProgress);
        wavesurfer.on('pause', restoreFadeVolume);

        // When song is finished show play button instead of pause button.
        wavesurfer.on('finish', function () {
            mainPlayerButton.classList.add("paused");
            localStorage.setItem('isPlaying', 'false');
            localStorage.setItem('currentTime', wavesurfer.getDuration());
            document.getElementById('wave-progress').innerHTML = formatTimecode(wavesurfer.getDuration());
            syncMusicLibraryTrackRows();
            publishPlayerState();
            document.dispatchEvent(new CustomEvent('ikson:player-ended', { detail: playerState() }));
        });

        publishPlayerState();

        document.addEventListener('ikson:music-library-tracks-updated', syncMusicLibraryTrackRows);

        // Delegate playback controls so Music Library content can be replaced without reinitialising the player.
        document.addEventListener("click", function (e) {
            var musicLibraryToggle = e.target.closest('[data-music-library-track-toggle]');
            var trigger = musicLibraryToggle
                ? musicLibraryToggle.closest('[data-music-library-track-row]')
                : e.target.closest('.playSong');

            if (!trigger) {
                return;
            }

            if (musicLibraryToggle
                && trigger.getAttribute('data-trackid') === activeTrackId) {
                togglePlayback();
                return;
            }

            activateTrack(trigger, 0, true);
        });

        // Event for main player PLAY button

        mainPlayerButton.addEventListener('click', function () {
            togglePlayback();
        })

        document.addEventListener('keydown', function (event) {
            var interactiveTarget = event.target && typeof event.target.closest === 'function'
                ? event.target.closest('input, textarea, select, button, a, summary, [contenteditable="true"]')
                : null;

            if ((event.key !== ' ' && event.code !== 'Space')
                || event.repeat
                || event.defaultPrevented
                || interactiveTarget
                || !activeTrackId) {
                return;
            }

            event.preventDefault();
            togglePlayback();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPlayer, { once: true });
    } else {
        initPlayer();
    }
})(window, document);
